import React from "react";
import AutomatedMessageText from "../../AutomatedMessageText";

const AutomatedMessageNewEnquiry = ({ thread, children }) => {
  const fromCall = thread.messages[0]?.offer?.call_thread;
  return (
    <AutomatedMessageText
      tagTitle={`New Enquiry${fromCall ? " from a Call" : ""}`}
    >
      {children}
    </AutomatedMessageText>
  );
};

export default AutomatedMessageNewEnquiry;
